<template>
  <div class="home bg-grey">
    <NavbarMain />
    <div class="bg-warning px-2 py-2 text-right d-flex">
      <div class="form-check ml-auto">
        <span
          class="btn btn-danger"
          v-if="product.state == 1"
          @click="changeStatusProduct(0)"
          >Inabilitar publicacion</span
        >
        <span class="btn btn-success" v-else @click="changeStatusProduct(1)"
          >Activar publicacion</span
        >
        <span class="ml-2 btn btn-danger d-none" @click="deleteProduct()"
          >Eliminar publicacion</span
        >
      </div>
    </div>
    <div class="alert alert-danger mt-2" role="alert" v-if="product.msgCancel">
      {{ product.msgCancel }}
    </div>
    <div class="container bg-white mt-5 mb-5 p-3 border-8 shadow-sm">
      <div class="row mt-5">
        <div class="col-xl-6 col-sm-12 col-md-5">
          <div
            class="img-fluid img-thumbnail img-squared mr-4 shadow-sm"
            :style="
              'background-image: url(' +
              url +
              'public/images/services/' +
              product.images[imageSelected] +
              '); height: 26.5em'
            "
          ></div>
        </div>
        <div class="col-xl-6 col-sm-12 col-md-7 pt-5">
          <InfoGeneralProduct :info="product" :changes="changes" />
          <div class="row pt-5">
            <div
              v-for="(image, index) in product.images"
              v-bind:key="index"
              class="
                img-fluid img-thumbnail img-squared
                d-inline
                mr-4
                cursor-pointer
              "
              :style="
                'background-image: url(' +
                url +
                'public/images/services/' +
                image +
                '); height: 6em;width: 6em'
              "
              @mouseover="imageSelected = index"
              :class="imageSelected == index ? 'border border-danger' : ''"
            ></div>
          </div>
        </div>
      </div>
      <div class="mt-5" v-if="product.videoYT">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe
            width="560"
            height="315"
            :src="'https://www.youtube.com/embed/' + product.videoYT"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="description pl-5 pr-5 pb-5">
        <h3 class="mt-5">Descripción</h3>
        <p style="white-space: pre-wrap">{{ product.description }}</p>
        <h3 class="mt-5" v-if="product.specs.length">Especificaciones</h3>
        <div class="row">
          <div
            class="col-md-6 col-sm-12"
            v-for="spec in product.specs"
            :key="spec._id"
          >
            <div v-if="spec.form != null && spec.value">
              <h5>{{ spec.form.name }}:</h5>
              <p style="white-space: pre-wrap">{{ spec.value }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalSuccess
      v-on:close="closeModal"
      title="Servicio actualizado"
      :description="`El servicio ha sido ${
        product.state == 1 ? 'activado' : 'inhabilitado'
      } con exito`"
      :visible="showModal"
    />
  </div>
</template>

<script>
import InfoGeneralProduct from "@/components/product/InfoGeneralProduct.vue";
import NavbarMain from "@/components/NavbarMain.vue";
import ModalSuccess from "../../components/modals/ModalSuccess.vue";
import Api from "../../tools/Api2";
import { mapState } from "vuex";
import Configs from "@/configs/configs";
import countries from "@/configs/countries";

export default {
  name: "AdminService",
  data() {
    return {
      showModal: false,
      imageSelected: 0,
      listCountries: [],
      product: {
        specs: [],
        sellerPlaceWorld: false,
        sellerPlaces: [],
        CityOfSale: "",
        category: {
          name: "",
        },
        description: "",
        discount: "",
        name: "",
        currency: "USA",
        price: "",
        sellerId: {
          username: "",
        },
        images: ["blank.png"],
      },
      url: Configs.API.BASE,
    };
  },
  components: {
    NavbarMain,
    ModalSuccess,
    InfoGeneralProduct
  },
  methods: {
    closeModal() {
      this.$router.push({ name: "AdminServices" });
    },
    deleteProduct() {
      Api("service")
        .delete(this.product._id)
        .then(() => {
          this.$router.push(`/admin/services`);
        });
    },
    changeStatusProduct(state) {
      Api("service")
        .patch(this.product._id, { state })
        .then((res) => {
          if (!res.error) {
            this.product.state = state;
            this.showModal = true;
          } else {
            alert(res.message);
          }
        });
    },

  },
  created: async function () {
    window.scrollTo(0, 0);
    Api("service")
      .get(this.$route.params.id)
      .then((res) => {
        res.service.sellerPlaces = res.service.sellerPlaces.filter(
          (e) => e != ""
        );
        this.listCountries = res.service.sellerPlaces.map((e) =>
          countries.find((f) => f.iso3 == e)
            ? countries.find((f) => f.iso3 == e).nombre
            : ""
        );
        if (!res.service.images.length) {
          res.service.images = ["blank.png"];
        }
        const specs = res.service.specs.filter(
          (e) => e.form != null && e.value != ""
        );
        const options = res.service.specs.filter(
          (e) => e.form != null && e.value == ""
        );
        this.product = { ...res.service, specs, options };

        if (!this.product.sellerId) return;
      });
  },
  computed: {
    ...mapState(["auth", "changes"]),
  },
};
</script>

<style scoped>
.old-price {
  text-decoration: line-through;
  font-size: 0.8em;
}

.old-price div {
  margin-left: 0.5em;
  text-decoration: line-through;
  text-decoration-color: grey;
  font-size: 0.8em;
}
</style>